var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIlustracaoExclamacao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 393.96 254.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #020202;\n      }\n\n      .cls-1, .cls-3, .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-4 {\n        mix-blend-mode: soft-light;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #e24040;\n      }\n\n      .cls-7 {\n        fill: #071d41;\n      }\n\n      .cls-8 {\n        fill: #f08080;\n      }\n\n      .cls-9 {\n        fill: url(#Gradiente_sem_nome_4);\n      }\n\n      .cls-10 {\n        opacity: .21;\n      }\n\n      .cls-10, .cls-3 {\n        fill: none;\n      }\n\n      .cls-11 {\n        fill: #0c326f;\n      }\n\n      .cls-12 {\n        fill: url(#Gradiente_sem_nome_4-3);\n      }\n\n      .cls-13 {\n        fill: url(#Gradiente_sem_nome_4-2);\n      }\n\n      .cls-14 {\n        fill: url(#Gradiente_sem_nome_11);\n      }\n\n      .cls-15 {\n        fill: #ffebe6;\n      }\n\n      .cls-16 {\n        fill: #1351b4;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    "data-name": "Gradiente sem nome 4",
    x1: 7558.58,
    y1: 98.27,
    x2: 7532.32,
    y2: 142.28,
    gradientTransform: "translate(7594.28) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5992ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#155bcb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4-2",
    "data-name": "Gradiente sem nome 4",
    x1: 7496.16,
    y1: 4.29,
    x2: 7386.33,
    y2: 244.6,
    xlinkHref: "#Gradiente_sem_nome_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4-3",
    "data-name": "Gradiente sem nome 4",
    x1: 6215.91,
    y1: -467.35,
    x2: 6104.15,
    y2: -222.81,
    gradientTransform: "translate(3494.51 -5067.32) rotate(118.72) scale(1 -1)",
    xlinkHref: "#Gradiente_sem_nome_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_11",
    "data-name": "Gradiente sem nome 11",
    x1: 7217.14,
    y1: 129.56,
    x2: 7577.34,
    y2: 129.56,
    gradientTransform: "translate(7594.28) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40e0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c5d4eb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fundo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor",
    className: "cls-9",
    d: "m40.04,95.09c-16.76,8.97-23.78,32.34-10.98,55.21,3.21,5.74,8.13,9.53,12.97,8.49,11.27-2.41,15.39-25.99,26.17-30.49,2.61-1.09,5.43-.94,7.89-2.63,13.56-9.31-5.65-46.85-36.04-30.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-2",
    "data-name": "cor",
    className: "cls-13",
    d: "m77.15,163.36c31.78,67.11,92.19,99.98,134.72,79.85,42.53-20.14,51.07-85.66,19.3-152.77C199.39,23.33,139.15-14.75,96.62,5.39c-42.53,20.14-51.25,90.86-19.47,157.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-3",
    "data-name": "cor",
    className: "cls-12",
    d: "m217.58,254.63c74.12,4.39,145.82-32.12,148.6-79.1,2.78-46.97-55.05-88.61-129.18-93-74.12-4.39-136.46,30.14-139.24,77.11-2.78,46.97,45.7,90.59,119.82,94.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-4",
    "data-name": "cor",
    className: "cls-14",
    d: "m333.96,21.17c-27.28-14.92-59.83-19.94-90.34-13.94-30.5,6.01-58.73,23-78.31,47.15-13.08,16.13-22.71,35.58-39.4,47.94-16.77,12.41-38.26,15.89-58.35,21.52-38.33,10.76-60.45,38.79-46.37,68.82,15.75,33.58,53.05,36.48,77.06,42.99,27.33,7.41,61.13,24.32,99.33,16.83,31.52-6.18,56.92-38.99,84.27-55.78,32.78-20.13,58.81-24.46,80.09-53.95,30.17-41.8,12.57-99.4-27.99-121.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "padroes"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m373.51,153c-.69-.5-.84-1.46-.35-2.15,1.18-1.64,2.32-3.32,3.39-5.02.45-.72,1.4-.93,2.12-.48.72.45.93,1.4.48,2.12-1.1,1.74-2.28,3.49-3.49,5.17-.3.42-.77.64-1.25.64-.31,0-.63-.09-.9-.29Zm8.54-13.67c-.76-.38-1.07-1.3-.7-2.06.89-1.81,1.74-3.66,2.5-5.5.32-.78,1.22-1.16,2.01-.83.78.33,1.15,1.22.83,2.01-.79,1.91-1.66,3.82-2.58,5.69-.27.54-.81.86-1.38.86-.23,0-.46-.05-.68-.16Zm6.13-14.91c-.81-.24-1.28-1.1-1.04-1.91.57-1.92,1.09-3.89,1.53-5.85.19-.83,1.01-1.35,1.84-1.16.83.19,1.35,1.01,1.16,1.84-.46,2.02-.99,4.05-1.58,6.04-.2.67-.81,1.1-1.47,1.1-.14,0-.29-.02-.44-.06Zm3.5-15.73c-.84-.1-1.45-.86-1.35-1.71.24-1.99.41-4.02.52-6.02.05-.85.78-1.5,1.62-1.45.85.05,1.5.77,1.45,1.62-.11,2.07-.29,4.16-.53,6.22-.09.78-.76,1.36-1.52,1.36-.06,0-.12,0-.18-.01Zm-.8-17.56c-.1-2-.26-4.03-.48-6.03-.09-.84.51-1.6,1.36-1.7.83-.09,1.6.51,1.7,1.36.23,2.06.39,4.15.5,6.22.04.85-.61,1.57-1.46,1.61-.03,0-.05,0-.08,0-.81,0-1.49-.64-1.53-1.46Zm-2.04-15.74c-.11-.53-.23-1.05-.34-1.58-.33-1.44-.69-2.89-1.07-4.31-.22-.82.26-1.66,1.08-1.89.82-.22,1.66.26,1.89,1.08.4,1.46.77,2.96,1.1,4.44.12.54.24,1.08.35,1.62.17.83-.36,1.65-1.19,1.82-.11.02-.21.03-.32.03-.71,0-1.35-.5-1.5-1.22Zm-4.45-15.26c-.71-1.88-1.49-3.77-2.31-5.6-.35-.78,0-1.68.78-2.03.78-.34,1.68,0,2.03.78.84,1.89,1.64,3.83,2.37,5.77.3.79-.1,1.68-.9,1.98-.18.07-.36.1-.54.1-.62,0-1.21-.38-1.44-.99Zm-6.75-14.37c-.99-1.74-2.06-3.48-3.16-5.17-.46-.71-.26-1.66.45-2.13.71-.46,1.66-.26,2.13.45,1.13,1.74,2.23,3.53,3.25,5.33.42.74.16,1.68-.57,2.1-.24.14-.5.2-.76.2-.53,0-1.05-.28-1.34-.78Zm-8.93-13.12c-1.26-1.57-2.59-3.11-3.94-4.59-.57-.63-.53-1.6.1-2.17.63-.57,1.6-.53,2.17.1,1.4,1.53,2.76,3.12,4.07,4.73.53.66.43,1.63-.23,2.16-.28.23-.63.34-.96.34-.45,0-.89-.2-1.2-.57Zm-10.94-11.49c-1.5-1.34-3.07-2.64-4.65-3.87-.67-.52-.79-1.49-.27-2.16.52-.67,1.49-.79,2.16-.27,1.63,1.27,3.24,2.62,4.8,4,.63.56.69,1.54.13,2.17-.3.34-.72.52-1.15.52-.36,0-.73-.13-1.02-.39Zm-12.69-9.49c-1.7-1.06-3.46-2.08-5.23-3.02-.75-.4-1.03-1.33-.63-2.08.4-.75,1.33-1.03,2.08-.63,1.83.98,3.65,2.03,5.41,3.13.72.45.94,1.4.49,2.12-.29.47-.79.72-1.31.72-.28,0-.56-.08-.81-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m65.42,240.97c-2.16-.43-4.14-.86-6.06-1.31-.83-.2-1.34-1.02-1.14-1.85.2-.83,1.03-1.34,1.85-1.14,1.89.45,3.84.87,5.96,1.29.83.17,1.37.97,1.21,1.81-.14.73-.79,1.24-1.51,1.24-.1,0-.2,0-.3-.03Zm-15.81-4.01c-2.02-.65-4-1.36-5.88-2.11-.79-.31-1.18-1.21-.86-1.99.31-.79,1.21-1.18,1.99-.86,1.82.72,3.73,1.41,5.69,2.04.81.26,1.25,1.13.99,1.94-.21.65-.81,1.06-1.46,1.06-.16,0-.32-.02-.47-.08Zm-15.09-6.42c-1.86-1.02-3.66-2.12-5.37-3.26-.71-.47-.89-1.43-.42-2.13.47-.71,1.43-.9,2.13-.42,1.63,1.09,3.36,2.14,5.14,3.12.74.41,1.02,1.34.61,2.09-.28.51-.81.8-1.35.8-.25,0-.5-.06-.74-.19Zm-13.39-9.58c-1.53-1.42-3.02-2.93-4.4-4.5-.56-.63-.5-1.61.13-2.17.64-.56,1.61-.5,2.17.13,1.32,1.49,2.73,2.93,4.19,4.28.62.58.66,1.55.08,2.17-.3.33-.72.49-1.13.49-.37,0-.75-.14-1.04-.41Zm-10.56-12.64c-1.11-1.73-2.17-3.56-3.15-5.43-.39-.75-.1-1.68.65-2.07.75-.39,1.68-.1,2.07.65.94,1.79,1.95,3.53,3.02,5.19.46.71.25,1.66-.46,2.12-.26.17-.54.24-.83.24-.51,0-1-.25-1.29-.71Zm-7.24-14.77c-.7-2-1.3-4.03-1.77-6.05-.2-.83.31-1.65,1.14-1.85.82-.19,1.65.31,1.85,1.14.45,1.91,1.02,3.84,1.68,5.74.28.8-.14,1.68-.94,1.96-.17.06-.34.09-.51.09-.63,0-1.23-.4-1.45-1.03ZM.08,177.36c-.05-.96-.08-1.93-.08-2.89,0-1.15.04-2.3.11-3.43.05-.85.79-1.5,1.63-1.44.85.05,1.49.78,1.44,1.63-.07,1.06-.1,2.15-.1,3.24,0,.9.02,1.82.07,2.73.04.85-.61,1.57-1.45,1.62-.03,0-.05,0-.08,0-.81,0-1.49-.64-1.53-1.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "objeto"
  }, /*#__PURE__*/React.createElement("g", {
    id: "objeto03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-5",
    "data-name": "cor",
    className: "cls-5",
    d: "m257.1,52.49v169.04c0,2.16-1.75,3.92-3.92,3.92h-106.6c-2.16,0-3.92-1.75-3.92-3.92V52.49c0-2.16,1.75-3.92,3.92-3.92h106.6c2.16,0,3.92,1.75,3.92,3.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "objeto-2",
    "data-name": "objeto"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-6",
    "data-name": "cor",
    className: "cls-11",
    d: "m257.1,68.92v-16.42c0-2.16-1.75-3.92-3.92-3.92h-106.6c-2.16,0-3.92,1.75-3.92,3.92h0v16.42h114.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "luz",
    className: "cls-16",
    d: "m176.77,68.92l15.34-20.35h-45.53c-2.16,0-3.92,1.75-3.92,3.92,0,0,0,0,0,.01v16.42h34.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "objeto-3",
    "data-name": "objeto",
    className: "cls-5",
    d: "m244.31,61.43h-47.18c-1.08,0-1.96-.88-1.96-1.96s.88-1.96,1.96-1.96h47.18c1.08,0,1.96.88,1.96,1.96s-.88,1.96-1.96,1.96h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "objetos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37",
    "data-name": "Grupo 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36",
    "data-name": "Grupo 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_33",
    "data-name": "Grupo 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_236",
    "data-name": "Caminho 236",
    className: "cls-7",
    d: "m232.07,198.92h-64.37c-1.15,0-2.08.94-2.08,2.09,0,1.15.93,2.08,2.08,2.08h64.37c1.15,0,2.08-.93,2.09-2.08,0-1.15-.93-2.08-2.08-2.09h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_237",
    "data-name": "Caminho 237",
    className: "cls-7",
    d: "m182.88,190.8h-15.17c-1.15,0-2.08.94-2.08,2.09,0,1.15.93,2.08,2.08,2.08h15.17c1.15,0,2.08-.94,2.08-2.09,0-1.15-.93-2.08-2.08-2.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35",
    "data-name": "Grupo 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_238",
    "data-name": "Caminho 238",
    className: "cls-7",
    d: "m192.89,190.8h31.52c1.15,0,2.08.94,2.08,2.09,0,1.15-.93,2.08-2.08,2.08h-31.61c-1.15,0-2.08-.93-2.08-2.08,0-.07,0-.14.01-.2.14-1.09,1.07-1.9,2.16-1.88h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_38",
    "data-name": "Grupo 38"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    className: "cls-7",
    cx: 175.19,
    cy: 182.66,
    r: 2.08
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    className: "cls-7",
    cx: 168.42,
    cy: 182.66,
    r: 2.08
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_37-2",
    "data-name": "Grupo 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_36-2",
    "data-name": "Grupo 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34-2",
    "data-name": "Grupo 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_237-2",
    "data-name": "Caminho 237",
    className: "cls-7",
    d: "m183.1,206.87h-15.17c-1.15,0-2.08.94-2.08,2.09,0,1.15.93,2.08,2.08,2.08h15.17c1.15,0,2.08-.94,2.08-2.09,0-1.15-.93-2.08-2.08-2.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_35-2",
    "data-name": "Grupo 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_238-2",
    "data-name": "Caminho 238",
    className: "cls-7",
    d: "m193.11,206.87h31.52c1.15,0,2.08.94,2.08,2.09,0,1.15-.93,2.08-2.08,2.08h-31.61c-1.15,0-2.08-.93-2.08-2.08,0-.07,0-.14.01-.2.14-1.09,1.07-1.9,2.16-1.88h0Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 142.67,
    y: 68.92,
    width: 114.43,
    height: 102.41
  })))), /*#__PURE__*/React.createElement("g", {
    id: "objeto02",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-7",
    "data-name": "cor",
    className: "cls-2",
    d: "m223.61,160.67l7.91-7.91,24.02,24.02-7.91,7.91-24.02-24.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    className: "cls-1",
    d: "m223.64,160.68l8.06,8.06c2.91-2.35,5.57-5.01,7.92-7.92l-8.07-8.06-7.92,7.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-8",
    "data-name": "cor",
    className: "cls-2",
    d: "m231.29,160.41c-18.05,18.05-47.31,18.05-65.36,0-18.05-18.05-18.05-47.31,0-65.36,18.05-18.05,47.31-18.05,65.36,0h0c18.02,18.06,18.02,47.3,0,65.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cor-9",
    "data-name": "cor",
    className: "cls-2",
    cx: 198.59,
    cy: 127.73,
    r: 34.76
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-10",
    "data-name": "cor",
    className: "cls-2",
    d: "m293.37,214.93l-7.56,7.56c-1.49,1.49-3.91,1.49-5.4,0h0s-35.81-35.81-35.81-35.81c-1.49-1.49-1.49-3.91,0-5.4h0s7.56-7.56,7.56-7.56c1.49-1.49,3.91-1.49,5.4,0h0s35.81,35.81,35.81,35.81c1.49,1.49,1.49,3.91,0,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra-2",
    "data-name": "sombra",
    className: "cls-1",
    d: "m274.44,216.51l5.97,5.97c1.49,1.49,3.91,1.49,5.4,0h0s7.56-7.56,7.56-7.56c1.49-1.49,1.49-3.91,0-5.4h0s-5.97-5.97-5.97-5.97l-12.96,12.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra-3",
    "data-name": "sombra",
    className: "cls-1",
    d: "m249.82,191.93l12.96-12.96,8.55,8.55-12.96,12.96-8.55-8.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "objeto02-2",
    "data-name": "objeto02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cor-11",
    "data-name": "cor",
    className: "cls-16",
    d: "m223.79,154.29l7.67-7.67,23.28,23.28-7.67,7.67-23.28-23.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra-4",
    "data-name": "sombra",
    className: "cls-4",
    d: "m223.82,154.3l7.81,7.81c2.82-2.28,5.4-4.85,7.68-7.68l-7.82-7.81-7.67,7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-12",
    "data-name": "cor",
    className: "cls-16",
    d: "m231.23,154.03c-17.49,17.49-45.85,17.49-63.34,0-17.49-17.49-17.49-45.85,0-63.34,17.49-17.49,45.85-17.49,63.34,0h0c17.46,17.5,17.46,45.84,0,63.34Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "cor-13",
    "data-name": "cor",
    className: "cls-5",
    cx: 199.54,
    cy: 122.36,
    r: 33.69
  }), /*#__PURE__*/React.createElement("path", {
    id: "cor-14",
    "data-name": "cor",
    className: "cls-8",
    d: "m291.4,206.88l-7.33,7.33c-1.44,1.44-3.79,1.45-5.23,0h0s-34.71-34.71-34.71-34.71c-1.44-1.44-1.45-3.79,0-5.23h0s7.33-7.33,7.33-7.33c1.44-1.44,3.79-1.45,5.23,0h0s34.71,34.71,34.71,34.71c1.44,1.44,1.44,3.79,0,5.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra-5",
    "data-name": "sombra",
    className: "cls-4",
    d: "m273.06,208.41l5.79,5.79c1.44,1.44,3.79,1.45,5.23,0h0s7.33-7.33,7.33-7.33c1.44-1.44,1.45-3.79,0-5.23h0s-5.79-5.79-5.79-5.79l-12.56,12.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sombra-6",
    "data-name": "sombra",
    className: "cls-4",
    d: "m249.2,184.59l12.56-12.56,8.29,8.29-12.56,12.56-8.29-8.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m207.11,141.22c0,4.56-3.71,8.27-8.27,8.27s-8.27-3.71-8.27-8.27,3.71-8.27,8.27-8.27,8.27,3.71,8.27,8.27Zm-15.58-42.05l1.41,28.11c.07,1.32,1.16,2.36,2.48,2.36h6.86c1.32,0,2.41-1.04,2.48-2.36l1.41-28.11c.07-1.42-1.06-2.6-2.48-2.6h-9.67c-1.42,0-2.55,1.19-2.48,2.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Camada_2-2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 250.74,
    y: 175.82,
    width: 17.84,
    height: 13.26,
    transform: "translate(-52.96 237.04) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m275.13,200.22h17.84v9.57c0,2.04-1.66,3.69-3.69,3.69h-10.45c-2.04,0-3.69-1.66-3.69-3.69v-9.57h0Z",
    transform: "translate(-63.07 261.44) rotate(-45)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracaoExclamacao);
export default __webpack_public_path__ + "static/media/ilustracao-exclamacao.45e7e78744565a49438a69198cb10f20.svg";
export { ForwardRef as ReactComponent };